import React from 'react';
import { Zap, Filter, Eye, Mail, Phone, Clock } from 'lucide-react';

const LeadFinderAnnouncementModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
    }}
    onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          backgroundColor: 'white',
          borderRadius: '8px',
          maxWidth: '48rem',
          width: '90%',
          maxHeight: '90vh',
          overflowY: 'auto',
          boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
        }}
      >
        {/* Header with gradient background */}
        <div style={{
          background: 'var(--gradient-brand)',
          padding: '32px 24px',
          borderRadius: '8px 8px 0 0',
          color: 'white',
          textAlign: 'center'
        }}>
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>🎉</div>
          <h2 style={{ fontSize: '28px', fontWeight: '700', marginBottom: '8px', margin: '0 0 8px 0' }}>
            Introducing: Lead Finder
          </h2>
          <p style={{ fontSize: '16px', opacity: 0.9, margin: 0 }}>
            A faster, smarter way to find your perfect leads
          </p>
        </div>

        {/* Benefits Section */}
        <div style={{ padding: '32px 24px' }}>
          <div style={{ marginBottom: '24px' }}>
            <h3 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '16px', color: 'var(--color-text-primary)', margin: '0 0 16px 0' }}>
              What's New? 🚀
            </h3>

            {/* Grid of benefits */}
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(2, 1fr)',
              gap: '16px',
              marginBottom: '24px'
            }}>
              <BenefitCard
                icon={<Zap size={24} color="#8B5CF6" />}
                title="Faster Extraction"
                description="Get your leads up to 3x faster than Apollo URL scraping"
              />
              <BenefitCard
                icon={<Eye size={24} color="#8B5CF6" />}
                title="Preview Results"
                description="See sample leads before committing to extraction"
              />
              <BenefitCard
                icon={<Filter size={24} color="#8B5CF6" />}
                title="Advanced Filtering"
                description="Filter directly on our platform - no Apollo navigation needed"
              />
              <BenefitCard
                icon={<Clock size={24} color="#8B5CF6" />}
                title="Flexible Quantities"
                description="Extract as few as 1 lead or up to 50,000 - your choice"
              />
              <BenefitCard
                icon={<Mail size={24} color="#8B5CF6" />}
                title="Email Filtering"
                description="Only get leads with verified email addresses"
              />
              <BenefitCard
                icon={<Phone size={24} color="#8B5CF6" />}
                title="Phone Filtering"
                description="Filter for leads with phone numbers included"
              />
            </div>
          </div>

          {/* Call to Action */}
          <div style={{
            background: 'var(--color-bg-inset)',
            borderRadius: '8px',
            padding: '20px',
            marginBottom: '24px',
            textAlign: 'center'
          }}>
            <p style={{ fontSize: '14px', color: 'var(--color-text-muted)', marginBottom: '12px', margin: '0 0 12px 0' }}>
              Ready to experience the next generation of lead generation?
            </p>
            <button
              onClick={() => {
                onClose();
                // Navigate to Lead Finder page
                window.location.href = '/dashboard/lead-finder';
              }}
              style={{
                background: 'var(--gradient-brand)',
                color: 'white',
                padding: '12px 32px',
                borderRadius: '6px',
                border: 'none',
                fontSize: '16px',
                fontWeight: '600',
                cursor: 'pointer',
                boxShadow: '0 4px 12px rgba(102, 126, 234, 0.4)',
                transition: 'transform 0.2s'
              }}
              onMouseEnter={(e) => e.target.style.transform = 'scale(1.05)'}
              onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
            >
              Try Lead Finder Now →
            </button>
          </div>

          {/* Close button */}
          <div style={{ textAlign: 'center' }}>
            <button
              onClick={onClose}
              style={{
                background: 'none',
                border: 'none',
                color: 'var(--color-text-muted)',
                fontSize: '14px',
                cursor: 'pointer',
                textDecoration: 'underline'
              }}
            >
              Maybe Later
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

// Benefit Card Component
const BenefitCard = ({ icon, title, description }) => (
  <div style={{
    padding: '16px',
    border: '1px solid var(--color-border)',
    borderRadius: '8px',
    display: 'flex',
    gap: '12px',
    background: 'white'
  }}>
    <div style={{ flexShrink: 0 }}>{icon}</div>
    <div>
      <h4 style={{ fontSize: '14px', fontWeight: '600', color: 'var(--color-text-primary)', marginBottom: '4px', margin: '0 0 4px 0' }}>
        {title}
      </h4>
      <p style={{ fontSize: '13px', color: 'var(--color-text-muted)', lineHeight: '1.4', margin: 0 }}>
        {description}
      </p>
    </div>
  </div>
);

export default LeadFinderAnnouncementModal;
